import React from 'react'
import type { DecorationsProps } from '../types'

// Rack has no decorations.
export const Decorations: React.FC<DecorationsProps> = () => null
